<template>
  <div class="app-nav" :class="{ 'dark-nav': dark }">
    <div class="app-nav__text">
      <div class="app-nav__back">
        <span class="app-nav__color" v-if="back">
          <van-icon
            color="var(--textColor)"
            name="arrow-left"
            @click="goback"
          />
        </span>
      </div>
      <div class="app-nav__title">
        <slot />
      </div>
    </div>
    <div class="app-nav__center">
      <slot name="center" />
    </div>
    <div class="app-nav__multi">
      <slot name="multi" />
      <slot name="recharge" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppNav",
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goback() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace("/home");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-nav {
  width: 100%;
  max-width: 750px;
  height: 0.88rem;
  padding: 0 0.24rem;
  margin: 0 auto;
  background: var(--bgColor);
  color: var(--textColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 0.01rem solid $border;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 100;

  &__text {
    display: flex;
    align-items: center;
  }

  &__back {
    // width: 20%;
    font-size: 0.4rem;

    .back-img {
      width: 0.18rem;
      // height: 0.44rem;
    }
  }

  &__title {
    font-size: 0.36rem;
    width: auto;
    color: var(--textColor);
  }

  &__center {
    width: auto;
    text-align: center;
    font-size: 0.26rem;
  }

  &__multi {
    width: auto;
    text-align: right;
    font-size: 0.26rem;
  }
}
.dark-nav {
  color: var(--textColor);
}
</style>



// WEBPACK FOOTER //
// src/components/AppTmpl/AppNav.vue